import { FC } from 'react'
import Image from 'next/image'

import {
  robinhoodLogo,
  walmartLogo,
  stashLogo,
  uberLogo,
  athletaLogo,
  taskrabbitLogo,
} from '@ui/assets'

export const TrustedBy: FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="font-display mb-12 text-center text-lg tracking-tight text-[#0a2d4a]">
          Trusted by 1,000+ brands worldwide
        </p>
        <div className="flex flex-wrap items-center justify-center gap-12 py-10 lg:justify-between">
          <Image
            src={robinhoodLogo}
            width={130}
            height={30}
            alt="Robinhood"
            className="h-[30px] w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
          <Image
            src={walmartLogo}
            width={140}
            height={30}
            alt="Walmart"
            className="h-[30px] w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
          <Image
            src={stashLogo}
            width={100}
            height={30}
            alt="Stash"
            className="h-[30px] w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
          <Image
            src={uberLogo}
            width={120}
            height={30}
            alt="Uber"
            className="h-[30px] w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
          <Image
            src={athletaLogo}
            width={110}
            height={30}
            alt="Athleta"
            className="h-[30px] w-auto"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
          <Image
            src={taskrabbitLogo}
            width={130}
            height={30}
            alt="TaskRabbit"
            className="hidden h-[30px] w-auto xl:block"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(11%) sepia(34%) saturate(2447%) hue-rotate(182deg) brightness(95%) contrast(101%)',
            }}
          />
        </div>
      </div>
    </section>
  )
}
